import { PostgrestError } from '@supabase/supabase-js'
import { useQuery } from '@tanstack/react-query'

import { useSupabase } from '@/hooks'

interface UseSubscriptionArgs {
  userId: string
  enabled?: boolean
}

const useSubscription = ({ userId, enabled }: UseSubscriptionArgs) => {
  const supabase = useSupabase()

  return useQuery({
    queryKey: ['subscription', userId],
    queryFn: async () => {
      const { data, error } = await supabase
        .schema('app_moments')
        .from('user_subscriptions')
        .select('*')
        .eq('user_id', userId)
        .single()

      if (error) {
        throw error as PostgrestError
      }

      if (!data) return { isActive: false }

      const now = new Date()
      const endDate = data.subscription_ended_at
        ? new Date(data.subscription_ended_at)
        : null

      return {
        isActive: endDate ? now < endDate : false,
        subscriptionId: data.subscription_id,
        purchaseId: data.purchase_id,
      }
    },
    enabled,
  })
}

export default useSubscription
